<template>
  <div>
    <expanding-insert-button
      :key="`insert-btn${updateKey}${alwaysOpen}`"
      :always-open="alwaysOpen"
      hide-close-button
    >
      <template #default="{ close }">
        <div class="etir-button-row mt-4 mb-2">
          <div class="etir-header-btn-area action-text">
            <action-button
              class="btn"
              color="primary"
              block
              :disabled="disabled"
              @click="onAddHeader"
            >
              <v-icon left>add</v-icon>
              Heading
            </action-button>
          </div>
          <div class="etir-field-btn-area">
            <action-button
              class="btn"
              color="primary"
              block
              :disabled="disabled"
              @click="onAddField"
            >
              <v-icon left>add</v-icon>
              Field
            </action-button>
          </div>
          <div v-if="!alwaysOpen" class="etir-close-btn-area">
            <action-button class="mr-5" @click="close">
              Cancel
            </action-button>
          </div>
        </div>
      </template>
    </expanding-insert-button>
  </div>
</template>

<script>
import ActionButton from '@/components/Common/ActionButton';
import ExpandingInsertButton from '@/components/Common/ExpandingInsertButton';

export default {
  name: 'ExtractionTemplateInsertRow',
  components: {
    ActionButton,
    ExpandingInsertButton,
  },
  props: {
    alwaysOpen: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['add-header', 'add-field'],
  data: () => ({
    updateKey: 0,
  }),
  methods: {
    wrapEmit(event) {
      const closeRow = () => {
        this.updateKey++;
      };
      this.$emit(event, closeRow);
    },
    onAddField() {
      this.wrapEmit('add-field');
    },
    onAddHeader() {
      this.wrapEmit('add-header');
    },
  },
};
</script>

<style lang="scss" scoped>
.etir-button-row {
  display: grid;
  grid-template-columns: auto auto auto;
  grid-gap: 1rem;
  min-height: 0;
  height: 100%;
  max-height: 100%;
  justify-content: center;
}

.etir-header-btn-area {
  .btn {
    grid-area: btn;
  }
}

.etir-field-btn-area {
  .btn {
    grid-area: btn;
  }
}
</style>
